// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 9922 ? "38205b58" : chunkId) + "." + {"1038":"80e93e9d00f4efa0","9922":"7b42b0fa6af41434"}[chunkId] + ".js";
};